import React from 'react';

const MisionSVG = () => (
  <svg
    className="prefix__animated"
    id="prefix__freepik_stories-target"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
  >
    <style>
      {
        "@keyframes slideUp{0%{opacity:0;transform:translateY(30px)}to{opacity:1;transform:inherit}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}@keyframes floating{0%,to{opacity:1;transform:translateY(0)}50%{transform:translateY(-10px)}}svg#prefix__freepik_stories-target:not(.prefix__animated) .prefix__animable{opacity:0}"
      }
    </style>
    <g
      id="prefix__freepik--Floor--inject-258"
      className="prefix__animable"
      style={{
        transformOrigin: "251.12px 349.34px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideUp",
        animationDelay: "0s",
      }}
    >
      <ellipse
        id="prefix__freepik--floor--inject-258"
        cx={251.12}
        cy={349.34}
        rx={230.41}
        ry={133}
        style={{
          transformOrigin: "251.12px 349.34px",
        }}
        className="prefix__animable"
        fill="#f5f5f5"
      />
    </g>
    <g
      id="prefix__freepik--Clouds--inject-258"
      className="prefix__animable"
      style={{
        transformOrigin: "394.67px 60.2736px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--clouds--inject-258"
        className="prefix__animable"
        style={{
          transformOrigin: "394.67px 60.2736px",
        }}
      >
        <path
          id="prefix__freepik--Cloud--inject-258"
          d="M436.84 69.49l-6.18-3.57a6.06 6.06 0 000-.76v-1.79a11 11 0 00-5-8.65 3.91 3.91 0 00-3-.58c-.45-4.53-3.6-9.65-7.42-11.85-4.12-2.39-7.47-.46-7.47 4.31v2.68a13.06 13.06 0 00.63 3.83l-5.13-3c-1.53-.88-2.77-.17-2.77 1.6a6.12 6.12 0 002.77 4.8l33.49 19.34c1.53.88 2.77.17 2.77-1.6a6.12 6.12 0 00-2.69-4.76z"
          style={{
            transformOrigin: "420.015px 58.7459px",
          }}
          className="prefix__animable"
          fill="#ebebeb"
        />
        <path
          id="prefix__freepik--cloud--inject-258"
          d="M354.23 49.83l3.41 1.31v-7.51c0-6 4.75-7.38 9.91-4.41 5.16 3 9.34 10.22 9.34 16.18v1.09a5 5 0 014.33.66 14.88 14.88 0 016.72 11.64v.5l4.75 2.71a9.79 9.79 0 014.43 7.66c0 2.83-2 4-4.43 2.56l-38.46-22.2a9.8 9.8 0 01-4.42-7.67c0-2.79 1.98-3.93 4.42-2.52z"
          style={{
            transformOrigin: "373.465px 60.2736px",
          }}
          className="prefix__animable"
          fill="#ebebeb"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Shadows--inject-258"
      className="prefix__animable"
      style={{
        transformOrigin: "246.9px 374.361px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
        animationDelay: "0s",
      }}
    >
      <ellipse
        id="prefix__freepik--Shadow--inject-258"
        cx={366.17}
        cy={399.56}
        rx={69.38}
        ry={40.05}
        style={{
          transformOrigin: "366.17px 399.56px",
        }}
        className="prefix__animable"
        fill="#e0e0e0"
      />
      <path
        id="prefix__freepik--shadow--inject-258"
        d="M101.1 403.86L214 338.68a1.36 1.36 0 000-2.58l-8.11-4.68a5 5 0 00-4.47 0l-45.83 26.46a4.87 4.87 0 01-4.46 0l-83.56-48.24a5 5 0 00-4.47 0l-3.92 2.26a1.36 1.36 0 000 2.58l83.64 48.29a1.36 1.36 0 010 2.58l-54.3 31.26a1.36 1.36 0 000 2.57l8.11 4.68a4.9 4.9 0 004.47 0z"
        style={{
          transformOrigin: "136.59px 356.756px",
        }}
        className="prefix__animable"
        fill="#e0e0e0"
      />
    </g>
    <g
      id="prefix__freepik--Plants--inject-258"
      className="prefix__animable"
      style={{
        transformOrigin: "95.5289px 359.593px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--plants--inject-258"
        className="prefix__animable"
        style={{
          transformOrigin: "95.5289px 359.593px",
        }}
      >
        <path
          d="M109.65 391l8-4.55s3.82-21.05 1-39.15c-4-25.44-21.34-34.22-27.63-31.69s-7.77 10.07 3.6 24.77c6.62 8.71 15.24 27.05 15.03 50.62z"
          style={{
            transformOrigin: "102.931px 353.096px",
          }}
          id="prefix__el4h3c8l18gmf"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__elljhc99id2r">
          <g
            style={{
              transformOrigin: "102.931px 353.096px",
            }}
            className="prefix__animable"
            id="prefix__elequobvmquof"
            opacity={0.15}
          >
            <path
              d="M109.65 391l8-4.55s3.82-21.05 1-39.15c-4-25.44-21.34-34.22-27.63-31.69s-7.77 10.07 3.6 24.77c6.62 8.71 15.24 27.05 15.03 50.62z"
              id="prefix__elu7t1xvlczj"
              className="prefix__animable"
              style={{
                transformOrigin: "102.931px 353.096px",
              }}
            />
          </g>
        </g>
        <path
          d="M112.53 380.94h-.07a.57.57 0 01-.49-.64c3.29-23.82-6.29-49.92-17-60.43a.58.58 0 010-.81.57.57 0 01.8 0c11 10.7 20.73 37.23 17.39 61.4a.58.58 0 01-.63.48z"
          style={{
            transformOrigin: "104.316px 349.919px",
          }}
          id="prefix__elcx2vfp3yqp5"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M87.55 403.81c-1.26.72-3.85-.86-4.85-1.53a11.92 11.92 0 01-4-4.58 11.18 11.18 0 01-1-6.76 26 26 0 01.85-3.59c.34-1.17.67-2.33 1-3.49a8.89 8.89 0 00.51-3.52c-.31-2.39-2.43-4.06-4.35-5.5-2.13-1.6-4.35-3.7-4.34-6.57a10.09 10.09 0 012.54-6c1.37-1.74 3-3.28 4.24-5.11a7.12 7.12 0 001.45-4.47 7.24 7.24 0 00-1-2.78c-1-1.87-2.35-3.59-3-5.6s-.6-4.51 1-5.94c1.29-1.18 3.2-1.35 4.94-1.23a11.27 11.27 0 014.6 1.61c4.56 2.54 7.16 7.94 12 9.89a46.79 46.79 0 005.86 1.43c2 .52 3.93 1.51 4.83 3.31 1.78 3.55-1.52 7.92-.27 11.69 1.11 3.33 4.34 4.61 6.16 7.61a7.11 7.11 0 01.85 4.37 20.61 20.61 0 01-1.84 7.37 51.77 51.77 0 01-4 6.64c-.16.06-21.99 12.64-22.18 12.75z"
          style={{
            transformOrigin: "93.4983px 370.551px",
          }}
          id="prefix__elyh2e71zp3u8"
          className="prefix__animable"
          fill="#0b345a"
        />
        <path
          d="M100.48 396.92a.57.57 0 01-.55-.59c.94-22.55-9.68-47.44-17.41-54.67a.57.57 0 010-.8.58.58 0 01.81 0c7.88 7.38 18.72 32.68 17.77 55.55a.58.58 0 01-.62.51z"
          style={{
            transformOrigin: "91.7573px 368.808px",
          }}
          id="prefix__el0oxv6tj74e3q"
          className="prefix__animable"
          fill="#fff"
        />
        <path
          d="M97.1 370.28a.5.5 0 01-.17 0 76 76 0 00-16.36-2.64.57.57 0 01.05-1.14 78.35 78.35 0 0116.65 2.69.56.56 0 01.37.71.55.55 0 01-.54.38z"
          style={{
            transformOrigin: "88.8461px 368.393px",
          }}
          id="prefix__elemqzoo1j5sf"
          className="prefix__animable"
          fill="#fff"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Target--inject-258"
      className="prefix__animable prefix__animator-active"
      style={{
        transformOrigin: "134.986px 209.342px",
        animation:
          "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight,1.5s Infinite linear floating",
        animationDelay: "0s,1s",
      }}
    >
      <g
        id="prefix__freepik--target--inject-258"
        className="prefix__animable"
        style={{
          transformOrigin: "134.986px 209.342px",
        }}
      >
        <g
          id="prefix__freepik--Canvas--inject-258"
          className="prefix__animable"
          style={{
            transformOrigin: "126.351px 252.436px",
          }}
        >
          <path
            style={{
              transformOrigin: "150.015px 330.645px",
            }}
            id="prefix__elj8juwf7wm4r"
            className="prefix__animable"
            fill="#37474f"
            d="M176.19 317.71v-2.94l-52.35 30.28 2.49 1.47 49.86-28.81z"
          />
          <path
            d="M110.91 118.38a.7.7 0 01.34.75L67.87 311.68l-1.23 5.46a3.4 3.4 0 01-1.74-.34l-2.9-1.71a.7.7 0 01-.33-.76l44.53-197.65a.7.7 0 011-.46z"
            style={{
              transformOrigin: "86.4585px 216.646px",
            }}
            id="prefix__el9mg24ztp3us"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M116.35 115.75L71.61 314.34a1.15 1.15 0 01-.56.75l-2.91 1.68a2.93 2.93 0 01-1.5.37l1.23-5.46 43.49-193z"
            style={{
              transformOrigin: "91.495px 216.445px",
            }}
            id="prefix__elck9r0iitdht"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M121.35 383.38v5.74a3.44 3.44 0 01-1.61-.36l-2.7-1.56a1.13 1.13 0 01-.65-.93V213.8l5 2.88z"
            style={{
              transformOrigin: "118.89px 301.46px",
            }}
            id="prefix__eld2hidhp60dm"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M126.34 213.81V386.3a1.12 1.12 0 01-.66.87l-2.68 1.56a3.2 3.2 0 01-1.63.39V216.68z"
            style={{
              transformOrigin: "123.855px 301.466px",
            }}
            id="prefix__el6coeao3wxix"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M186.07 351.76a3.38 3.38 0 01-1.56-.45l-2.78-1.61a1.41 1.41 0 01-.68-1l-29.74-155.09 5 2.88L185 346.18z"
            style={{
              transformOrigin: "168.69px 272.685px",
            }}
            id="prefix__elq762ey5czbi"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M191.05 348.85a1.16 1.16 0 01-.69.94l-2.54 1.48-.12.07a3.36 3.36 0 01-1.63.39l-1.07-5.55-28.7-149.69 5-2.87 29.69 155z"
            style={{
              transformOrigin: "173.675px 272.675px",
            }}
            id="prefix__eldi3r58te6wc"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            style={{
              transformOrigin: "152.895px 334.045px",
            }}
            id="prefix__elmue4lwdhsoa"
            className="prefix__animable"
            fill="#455a64"
            d="M124.62 353.25l56.55-32.65v-5.76l-56.55 32.65v5.76z"
          />
        </g>
        <path
          d="M183.62 45.47l-.1-.06-.27-.15c-1.45-.82-7.45-4.2-20.4-11.63-10.33-5.94-23.15-5.58-37 2.44C91.61 55.82 63.89 114.5 63.9 167.15c0 31.25 9.78 53.36 24.87 62 9.08 5.21 18.4 10.49 20.52 11.7a1.71 1.71 0 01.23.13l.22.12c10.26 5.71 22.94 5.27 36.66-2.65 34.19-19.75 61.91-78.43 61.91-131.08.01-31.12-9.69-53.17-24.69-61.9z"
          style={{
            transformOrigin: "136.105px 137.257px",
          }}
          id="prefix__elypcan0f9n6"
          className="prefix__animable"
          fill="#0b345a"
        />
        <g id="prefix__elorssciaczm">
          <path
            d="M183.62 45.47l-.1-.06-.27-.15c-1.45-.82-7.45-4.2-20.4-11.63-10.33-5.94-23.15-5.58-37 2.44C91.61 55.82 63.89 114.5 63.9 167.15c0 31.25 9.78 53.36 24.87 62 9.08 5.21 18.4 10.49 20.52 11.7a1.71 1.71 0 01.23.13l.22.12c10.26 5.71 22.94 5.27 36.66-2.65 34.19-19.75 61.91-78.43 61.91-131.08.01-31.12-9.69-53.17-24.69-61.9z"
            style={{
              transformOrigin: "136.105px 137.257px",
            }}
            className="prefix__animable"
            id="prefix__elou7w8bziz7q"
            opacity={0.1}
          />
        </g>
        <g id="prefix__elwwj5efevlc8">
          <path
            d="M195.1 173.9L75.51 104.85c-7.31 19.87-11.61 41.55-11.61 62.3 0 31.25 9.78 53.36 24.87 62 9.08 5.21 18.4 10.49 20.52 11.7a1.71 1.71 0 01.23.13l.22.12c10.26 5.71 22.94 5.27 36.66-2.65 19.77-11.39 37.37-35.81 48.7-64.55z"
            style={{
              transformOrigin: "129.5px 174.901px",
            }}
            className="prefix__animable"
            id="prefix__elo5x32q56xkk"
            opacity={0.1}
          />
        </g>
        <g id="prefix__el3oj56ffqnzw">
          <path
            d="M64 173.07c1.17 28.13 10.63 48 24.75 56.1 9.08 5.21 18.4 10.49 20.52 11.7a1.71 1.71 0 01.23.13l.22.12c10.26 5.71 22.94 5.27 36.66-2.65a77.65 77.65 0 0013.47-10.05z"
            style={{
              transformOrigin: "111.925px 209.021px",
            }}
            className="prefix__animable"
            id="prefix__el68xi13h6gj"
            opacity={0.1}
          />
        </g>
        <path
          d="M146.4 47.82c-34.19 19.74-61.9 78.42-61.9 131.07s27.72 79.32 61.91 59.58 61.91-78.47 61.91-131.08-27.72-79.32-61.92-59.57z"
          style={{
            transformOrigin: "146.41px 143.145px",
          }}
          id="prefix__elgt011t4pxmm"
          className="prefix__animable"
          fill="#0b345a"
        />
        <path
          d="M146.4 66.75c-27.4 15.82-49.61 62.85-49.61 105s22.22 63.57 49.62 47.75S196 156.68 196 114.49s-22.19-63.57-49.6-47.74z"
          style={{
            transformOrigin: "146.395px 143.12px",
          }}
          id="prefix__elbixck1lb9ul"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M146.41 85.68c-20.62 11.9-37.32 47.28-37.32 79s16.71 47.82 37.32 35.92 37.32-47.28 37.32-79S167 73.77 146.41 85.68z"
          style={{
            transformOrigin: "146.41px 143.138px",
          }}
          id="prefix__elipr060vcx0m"
          className="prefix__animable"
          fill="#0b345a"
        />
        <path
          d="M146.41 104.61c-13.83 8-25 31.7-25 53s11.21 32.07 25 24.09 25-31.71 25-53-11.18-32.08-25-24.09z"
          style={{
            transformOrigin: "146.41px 143.154px",
          }}
          id="prefix__elpw0btutvsef"
          className="prefix__animable"
          fill="#fafafa"
        />
        <path
          d="M146.41 123.53c-7 4.07-12.74 16.14-12.73 27s5.7 16.32 12.73 12.26 12.73-16.13 12.73-27-5.7-16.32-12.73-12.26z"
          style={{
            transformOrigin: "146.41px 143.159px",
          }}
          id="prefix__elremk6hiapfg"
          className="prefix__animable"
          fill="#455a64"
        />
      </g>
    </g>
    <g
      id="prefix__freepik--Character--inject-258"
      className="prefix__animable"
      style={{
        transformOrigin: "311.95px 265.589px",
        animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
        animationDelay: "0s",
      }}
    >
      <g
        id="prefix__freepik--character--inject-258"
        className="prefix__animable"
        style={{
          transformOrigin: "311.95px 265.589px",
        }}
      >
        <g
          id="prefix__freepik--character--inject-258"
          className="prefix__animable"
          style={{
            transformOrigin: "337.564px 265.589px",
          }}
        >
          <g
            id="prefix__freepik--character--inject-258"
            className="prefix__animable"
            style={{
              transformOrigin: "361.539px 321.808px",
            }}
          >
            <path
              d="M379.39 378.89c-.26 1.88-1.12 3.42 1.34 7.79 1.91 3.38 4.67 4.79 6.45 6a27.87 27.87 0 015.35 5 23.83 23.83 0 005.62 5.44c1.68 1.11 6 .68 7.89-.44s2.5-2.93 1.95-6.19-10.63-3.11-10.63-3.11z"
              style={{
                transformOrigin: "393.608px 391.329px",
              }}
              id="prefix__elqwgve4twckm"
              className="prefix__animable"
              fill="#37474f"
            />
            <path
              d="M406.31 359l-.5 30.58c0 1.8-9.87 4.05-12-.06a67.52 67.52 0 00-1.48-9.38c-.77-3.07-2.08-8.41-2.08-8.41-1.12-6.37-1.62-11.07-1.62-11.07z"
              style={{
                transformOrigin: "397.47px 375.419px",
              }}
              id="prefix__elycribjzkn4"
              className="prefix__animable"
              fill="#ffa8a7"
            />
            <path
              d="M360.86 373.08s-4.65 28.3-4.79 29.86-4.53 2.57-7.78 2.47-5.17-1.61-5.14-2.31l-.8-30.2z"
              style={{
                transformOrigin: "351.605px 389.158px",
              }}
              id="prefix__eld6ct73j01pi"
              className="prefix__animable"
              fill="#ffa8a7"
            />
            <path
              d="M365 335.39s.4-5.45 3.62-21.9c2.24-11.4 4.1-23.64 4.1-23.64s4 14.76 6.35 26.39c1.68 8.46 3.37 16.43 6.63 32.55a200.64 200.64 0 005.2 21c6.27 3.33 15.44-.49 15.44-.49s.38-9.83.25-22c-.16-15.76-3.61-21.93-3.61-21.93s-1.33-21.25-2-36.94c-.9-22.25-.21-43-5.45-60.32-.81-.22-50-21.71-51.28 7.72-.31 7.27-.85 26.62-1.37 42.15-.89 26.32-.64 45.9-.67 54.86-.18 8.63-.26 16.72-.1 32.82.08 7 .49 13 .49 13 5.9 4 18.51-.88 18.51-.88s.56-6.92 2.3-16.7c3.1-17.08 1.59-25.69 1.59-25.69z"
              style={{
                transformOrigin: "374.321px 300.284px",
              }}
              id="prefix__el6ak62nfo1jt"
              className="prefix__animable"
              fill="#37474f"
            />
            <g id="prefix__el8ytg4tbtk6b">
              <g
                style={{
                  transformOrigin: "364.79px 258.42px",
                }}
                className="prefix__animable"
                id="prefix__elqvp1cogejr"
                opacity={0.2}
              >
                <path
                  d="M364.87 270.11c-2.77-.8-8.34-4.07-9.37-6.15-1.19-2.39-1.45-14.94-1.46-15.47V248l20.25-1.44.06.44a127 127 0 011.19 13.82v.65c.08 2-7.89 8.14-8.7 8.63a1.29 1.29 0 01-.66.18 4.6 4.6 0 01-1.31-.17zM355 248.92c.09 3.87.48 12.86 1.36 14.62s6 4.87 8.78 5.66c1 .28 1.22.14 1.23.14 1.74-1.07 8.29-6.66 8.25-7.8v-.66a121.9 121.9 0 00-1.12-13.28z"
                  id="prefix__el151n7vme78e"
                  className="prefix__animable"
                  style={{
                    transformOrigin: "364.79px 258.42px",
                  }}
                />
              </g>
            </g>
            <g id="prefix__elbw6srubrppl">
              <g
                style={{
                  transformOrigin: "394.73px 253.74px",
                }}
                className="prefix__animable"
                id="prefix__el7vigr3iiakm"
                opacity={0.2}
              >
                <path
                  d="M400.3 264.69l.19-1c-3.43-1.65-8.42-4.4-8.8-5.33-.47-1.14-1.35-9.15-1.7-12.64 1-.26 4.13-1 8.82-2l-.19-.93c-5.86 1.24-9.23 2.13-9.26 2.14l-.39.1v.4c.12 1.2 1.18 11.77 1.8 13.31s8.1 5.26 9.53 5.95z"
                  id="prefix__elbwm5xc74if"
                  className="prefix__animable"
                  style={{
                    transformOrigin: "394.73px 253.74px",
                  }}
                />
              </g>
            </g>
            <path
              d="M342.26 370.65l.09 2.25s1.81 2.36 9.57 2.52 9.78-1.86 9.78-1.86l.25-1.88c1.24.29 1 1.76.18 5.43s-1.5 6.84-2.3 7.6-5 2.06-9.55 1.85-7.54-2.1-8.34-3.2-1.07-5.5-1.29-7.87.26-4.75 1.61-4.84z"
              style={{
                transformOrigin: "351.706px 378.616px",
              }}
              id="prefix__el9cmh3s68e1"
              className="prefix__animable"
              fill="#0b345a"
            />
            <path
              d="M387.88 358.64l.55 2.25s1.77 2 9.51 1.34 8.64-2.83 8.64-2.83v-1.82c1.65.25 2.08 1.55 1.66 5.28s-.79 7-1.5 7.8-4.73 2.55-9.31 2.82-6.74-1.15-7.64-2.16-1.72-5.82-2.18-8.16-1.05-4.28.27-4.52z"
              style={{
                transformOrigin: "397.731px 365.547px",
              }}
              id="prefix__elka622oqmbrf"
              className="prefix__animable"
              fill="#0b345a"
            />
            <g id="prefix__elr8wd8v2jz8">
              <path
                d="M372.73 289.85l3.53-17.46a16.87 16.87 0 009.11-11.27s.59 8-6.38 12l-4.34 16.64 1.73 14.34z"
                style={{
                  transformOrigin: "379.056px 282.61px",
                }}
                className="prefix__animable"
                id="prefix__el0zpsphoh3wbq"
                opacity={0.2}
              />
            </g>
            <path
              d="M315.24 413.44c-.7-.07-.62 2-.38 2.94s3.13 3.93 8.27 5 12.23.11 15.28 0 8.3 1.36 11.33 1.8 8.5-.58 10.31-2.29a3.18 3.18 0 00.74-2.51c-.06-2-.24-2.43-.48-2.41z"
              style={{
                transformOrigin: "337.754px 418.36px",
              }}
              id="prefix__el90yl0nhl2yl"
              className="prefix__animable"
              fill="#37474f"
            />
            <path
              d="M359.33 399.66a19 19 0 00.64-3.33 6.16 6.16 0 00-.39-2.76 2.92 2.92 0 00-1.84-1.38l-.44 2.81c-.59.57-2.25.83-2.93 1.27-1.53 1-1.83 3.07-2.23 4.85a2.79 2.79 0 01-.46 1.17c-1.38 1.71-1.78-1.28-1.85-2.08-.1-1.16-.2-2.45-1.06-3.24a5.47 5.47 0 00-3-1c-1.05-.09-2.3-.05-2.87-1l-.07-1.77c-.89-.1-2.16.07-2.53 1a3.13 3.13 0 00-.08 1.43c.14 1.33.33 2.66.59 4a14.91 14.91 0 01.45 3 5.09 5.09 0 010 .56 3 3 0 01-1 1.07 12.81 12.81 0 01-5.24 1.22c-2.64.17-4.88-.23-7.85-.27a15.82 15.82 0 00-7.9 1.61 7.1 7.1 0 00-4 7 9.81 9.81 0 004.7 4.26 25.41 25.41 0 007.78 1.68c3.13.32 7.46-.23 10.6-.41a30.24 30.24 0 017.84.83c4 .8 6.72 1 10.33-.08 1.37-.42 3.07-1.23 3.7-2.74a19.9 19.9 0 00-.37-6.2c-.07-.41-.15-.81-.24-1.21s-.24-1-.37-1.48c-.2-.75-.21-1.57-.34-2.34-.05-.28-.2-1-.39-1.91a23.18 23.18 0 01.4-2.61c.09-.61.26-1.31.42-1.95z"
              style={{
                transformOrigin: "337.779px 406.518px",
              }}
              id="prefix__el3swifpd6zyr"
              className="prefix__animable"
              fill="#455a64"
            />
            <path
              d="M339.43 404.58a9.12 9.12 0 00-3.17 6c.06 1.52-2.62 1.62-2.68.11a13 13 0 012.42-5.32 4.84 4.84 0 013.43-.79z"
              style={{
                transformOrigin: "336.505px 408.151px",
              }}
              id="prefix__elieyqg0cabc"
              className="prefix__animable"
              fill="#fafafa"
            />
            <path
              d="M333.6 405.47a9.49 9.49 0 00-2.93 5.11c-.05 1.12-2.38 1-2.33-.12 0 0 .36-3.59 2.94-5.08.72-.51 2.08-.38 2.32.09z"
              style={{
                transformOrigin: "330.97px 408.208px",
              }}
              id="prefix__el0pvqcr242t2"
              className="prefix__animable"
              fill="#fafafa"
            />
            <path
              d="M329 405.23c-1.23 0-3.81 1.64-5.08 5.4a21.44 21.44 0 00-.58 8.5 12 12 0 01-6.8-3.24 7 7 0 01-1.7-2.16 7.51 7.51 0 011.29-5.74c1.79-2.12 4.55-3.51 8.89-3.73 4.87-.25 5.29 1.05 5.29 1.05z"
              style={{
                transformOrigin: "322.513px 411.679px",
              }}
              id="prefix__eln5p32dcpr6j"
              className="prefix__animable"
              fill="#fafafa"
            />
            <path
              d="M382.06 374.89c2.41-1.41 9.37 1.77 9.37 1.77l.41 1.63s.29 1.16.44 1.73c.36 1.29 2 1.71 3.2 1.88a18 18 0 009.15-1.59c1.27-.7 1.35-1.47 1.35-1.47v-1.71c.78 0 1.67.36 1.54 2-.23 2.94-.49 8.07 0 10.74.22 1.32.59 2.87.78 4.18.14.89.1 3.51-1.07 4.56a4.31 4.31 0 01-1.17 1c-2.54 1.58-7 1.32-9.08-.74-2.64-2.56-4.5-4.89-8.2-8-2.19-1.82-4.3-2.69-6.08-4.93a14.12 14.12 0 01-2.21-4.26c-1.33-3.68-.91-5.34 1.57-6.79z"
              style={{
                transformOrigin: "394.052px 387.58px",
              }}
              id="prefix__elfnne9j1g2m8"
              className="prefix__animable"
              fill="#455a64"
            />
            <path
              d="M389.06 384.42a8.75 8.75 0 013.25-4.27c-.15-.61-.32-1.23-.47-1.86a9.17 9.17 0 00-4.8 5.32c-.35 1.12 1.24 1.75 2.02.81z"
              style={{
                transformOrigin: "389.65px 381.583px",
              }}
              id="prefix__elmj87ogixwa"
              className="prefix__animable"
              fill="#fafafa"
            />
            <path
              d="M392.66 386a8.31 8.31 0 01.72-1.53c-.21-.83-.43-1.72-.67-2.66a9.1 9.1 0 00-2.06 3.38c-.35 1.07 1.24 1.7 2.01.81z"
              style={{
                transformOrigin: "391.99px 384.117px",
              }}
              id="prefix__elp1yjx1wb0l9"
              className="prefix__animable"
              fill="#fafafa"
            />
            <path
              d="M382.68 386.08c0-.29-.42-7.16 8.75-9.41 0-.05-.16-.65-.23-.9a8.05 8.05 0 00-4.21-2c-3.35-.46-5.79.7-7.21 3.11s1.04 8.01 2.9 9.2z"
              style={{
                transformOrigin: "385.394px 379.875px",
              }}
              id="prefix__elwuk6dmtrpt"
              className="prefix__animable"
              fill="#fafafa"
            />
          </g>
          <path
            d="M329.21 186.7c-3.87-.91-10.81-3-18.53-5.66-8.49-3-17.33-5.61-18.82-5.88-2.84-.51-6.91-.24-9.43-.92-3-.82-6.05-1.06-8.68-3a3.24 3.24 0 01-1.53-2.21c0-.47.11-.94.09-1.41 0-.74-.49-1.42-.41-2.15.1-1 1.16-1.74 1.2-2.75a6.56 6.56 0 00-.24-1.31c-.12-.8.67-1.87 1.11-2.52.24-.34.91-.94.53-1.39a34 34 0 00-4.23-4c-2.78-2.33-4.3-4.46-3.14-5.79 1.6-1.85 4.54.54 8.26 3.14 2.07 1.45 4.1 3 6.2 4.38.82.55 4.14 3.26 5 1.9a2.31 2.31 0 00.21-1.45c-.09-1-.27-2.07-.29-3.11a6 6 0 01.6-3 2.17 2.17 0 01.76-.88 1.12 1.12 0 011.12-.05 1.74 1.74 0 01.66 1c.48 1.25.95 2.5 1.42 3.75a28.09 28.09 0 002.64 6.05 10.57 10.57 0 003.56 3.48c1 .47 7.66 2.08 9.84 2.61 3.76.9 25.13 5.31 25.55 5.41l57.52-6.26-.8 18.74s-52.59 5.07-60.17 3.28z"
            style={{
              transformOrigin: "328.459px 167.069px",
            }}
            id="prefix__elzibo3d026wo"
            className="prefix__animable"
            fill="#ffa8a7"
          />
          <path
            d="M387.4 162.83c3.91-.52 9.81-.48 13.16 3.91s3.31 7.87 3.27 13.47-2.78 15.58-2.78 15.58z"
            style={{
              transformOrigin: "395.619px 179.197px",
            }}
            id="prefix__ellrhsrnv36ia"
            className="prefix__animable"
            fill="#0b345a"
          />
          <path
            d="M282.77 163.48a1 1 0 01-.24.8 1.08 1.08 0 01-.79.29 4 4 0 01-.85-.11c-.23 0-.54 0-.6.2a.47.47 0 00.14.38 10.89 10.89 0 001.27 1.07c.55.48 1.21 1.39.6 2a1.6 1.6 0 01-1.41.53c-.39 0-.78-.15-1.18-.17-.07 0-.16 0-.15.1a.18.18 0 00.05.07 5.89 5.89 0 011.46 1.35 1.4 1.4 0 01.25 1.21c-.2.48-1 .72-1.44.75h-.23v.05h.07a3.17 3.17 0 00.44.12 1.54 1.54 0 001.68-1.15 1.69 1.69 0 00-.53-1.79 2 2 0 001.82-.72c1-1.11.35-2.05-.53-2.89a1.78 1.78 0 00.83-.39 11.56 11.56 0 001.95 5.63 18.6 18.6 0 01-1.11-6.65 8.21 8.21 0 01.16-1.64 14.46 14.46 0 01.28-1.46 10.72 10.72 0 01.73-2.29 4.33 4.33 0 00-1.3 1.22c-.3.43-.28 1.08-.94 1.15a1.81 1.81 0 01-1.06-.32 3.21 3.21 0 00-1-.47.26.26 0 00-.23.05c-.07.09 0 .22.08.31a6.64 6.64 0 011.75 2.36 1.06 1.06 0 01.03.41z"
            style={{
              transformOrigin: "282.5px 165.451px",
            }}
            id="prefix__eltejg8p7dpb9"
            className="prefix__animable"
            fill="#f28f8f"
          />
          <path
            style={{
              transformOrigin: "372.49px 164.705px",
            }}
            id="prefix__eljv0bpcwbmlb"
            className="prefix__animable"
            fill="#ffa8a7"
            d="M362.38 156l1.91 18.34 18.31 1-1.46-21.27-18.76 1.93z"
          />
          <path
            d="M351.68 134.05s-4.64 6.29-4.19 7 3.59 1.41 3.59 1.41z"
            style={{
              transformOrigin: "349.57px 138.255px",
            }}
            id="prefix__elffm0siyp2se"
            className="prefix__animable"
            fill="#f28f8f"
          />
          <path
            d="M364.57 116.66c-8.79 1.37-11.51 5-13.06 18.82-1.63 14.39-.39 19 1.4 21.05 1.21 1.38 8.31 2 11.95 1.19 4.56-1 14.89-4.05 20-11.06 6.05-8.24 8.14-19.74 2.4-24.8-8.03-7.13-19.11-5.76-22.69-5.2z"
            style={{
              transformOrigin: "370.694px 137.127px",
            }}
            id="prefix__elwsdxeuvvrgi"
            className="prefix__animable"
            fill="#ffa8a7"
          />
          <path
            d="M350.51 121.26a11.79 11.79 0 002.12 1.87 30.68 30.68 0 003.53 2.21 22.68 22.68 0 013.44 1.84c1.52 1.21 1.64 2.71 1.58 4.53 0 1.19-.11 2.66-.18 4.25-.1 2.4 1.33 4.3 2.25 1.13 0 0 1.66-5.26 6.12-4.35s4.58 6 2.23 9.86c-1.44 2.35-4.9 1.53-4.9 1.53a15.75 15.75 0 004.05 12.35s3.47 2.05 10.62.92c5.2-6.41 8.42-9.48 11.31-15.1 6.12-11.87 3.89-19.65-.17-23.09-.54-5.65-4.82-8.4-9.79-9.83-7.44-2.13-14.71 2-22.07-.1a36.35 36.35 0 01-3.58-1.14 2 2 0 00-1.46-.18 1.65 1.65 0 00-.8 1.62 4.51 4.51 0 002 3.65c-.15-.1-.89.06-1.09.06h-1.25A22.6 22.6 0 01352 113a4.58 4.58 0 00-1.69 0 3.05 3.05 0 00-2.09 3 7.58 7.58 0 001.15 3.69 10.29 10.29 0 00.83 1.34 4 4 0 00.31.23z"
            style={{
              transformOrigin: "372.341px 132.818px",
            }}
            id="prefix__elu2b3wkb1hsa"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M352.91 156.53c1 1.11 5.81 1.73 9.55 1.5h.26l-.26-2s-5.98 1.38-9.55.5z"
            style={{
              transformOrigin: "357.815px 157.054px",
            }}
            id="prefix__el9vtx82t29j6"
            className="prefix__animable"
            fill="#f28f8f"
          />
          <path
            d="M399.54 172.47c-2.25-5.42-7.13-10.55-13.41-9.51-1.46.24-2.85.36-4.23.61-.74 3.07-10.53 3.36-18.57 1.5l-9.43 1.13c-5.77 1.94-10.41 13.07-11.23 30s.09 43 .42 54.79a64.86 64.86 0 0036.57 3.75c17.29-3.44 20.11-10.86 20.11-10.86l-1.33-30.26c0-6.58 2.4-15.5 2.91-19.73 1.54-13.01-.45-18.13-1.81-21.42z"
            style={{
              transformOrigin: "372.123px 209.337px",
            }}
            id="prefix__elvah5gnq6ds"
            className="prefix__animable"
            fill="#455a64"
          />
        </g>
        <g
          id="prefix__freepik--Dart--inject-258"
          className="prefix__animable"
          style={{
            transformOrigin: "311.593px 235.993px",
          }}
        >
          <path
            d="M228.47 184.69a3.06 3.06 0 00-1.21 2.45.94.94 0 00.46.85l32.79 16.27 1.71-3.45-32.79-16.27a1 1 0 00-.96.15z"
            style={{
              transformOrigin: "244.74px 194.369px",
            }}
            id="prefix__elh3lomaspso"
            className="prefix__animable"
            fill="#455a64"
          />
          <path
            d="M227.72 188c-4-2-12.21-8.2-12.21-8.2s11.92 3.73 13.92 4.75z"
            style={{
              transformOrigin: "222.47px 183.9px",
            }}
            id="prefix__eloy7652h3l9q"
            className="prefix__animable"
            fill="#455a64"
          />
          <g id="prefix__el9s4vmxkznum">
            <path
              style={{
                transformOrigin: "238.385px 191.21px",
              }}
              className="prefix__animable"
              id="prefix__eloydjoyqma7"
              fill="#fff"
              opacity={0.2}
              d="M261.26 200.97L229 185.06l-13.49-5.27 13.02 6.56 32.61 16.28.12-1.66z"
            />
          </g>
          <path
            d="M261.26 201a3 3 0 00-1.21 2.44c.06.87.69 1.18 1.41.7a3 3 0 001.21-2.45c-.06-.89-.67-1.21-1.41-.69z"
            style={{
              transformOrigin: "261.36px 202.558px",
            }}
            id="prefix__elnp7pn10e0e"
            className="prefix__animable"
            fill="#37474f"
          />
          <path
            d="M260.1 201.84c4.57-8.41 27.07-19.59 45.69-10.38S358.91 236.35 368 255c-21.84 3.75-66.48.32-84.45-8.56s-27.33-25.02-23.45-44.6z"
            style={{
              transformOrigin: "313.616px 222.252px",
            }}
            id="prefix__elq5scazk4eit"
            className="prefix__animable"
            fill="#0b345a"
          />
          <g id="prefix__elvd3ulwbd2tf">
            <path
              d="M260.1 201.84c4.57-8.41 27.07-19.59 45.69-10.38S358.91 236.35 368 255c-21.84 3.75-66.48.32-84.45-8.56s-27.33-25.02-23.45-44.6z"
              style={{
                transformOrigin: "313.616px 222.252px",
              }}
              className="prefix__animable"
              id="prefix__el6w2jx1xmh07"
              fill="#fff"
              opacity={0.7}
            />
          </g>
          <path
            d="M276 231.29c-.92-14.21 6.66-31.29 16.93-38.13 4.34-2.9 8.46-3.5 11.85-2.15-18.42-8.35-40.21 2.57-44.7 10.83-3.88 19.58 5.52 35.7 23.48 44.58-4.14-2.11-7.04-7.42-7.56-15.13z"
            style={{
              transformOrigin: "281.997px 217.219px",
            }}
            id="prefix__elb0847hc6hs"
            className="prefix__animable"
            fill="#0b345a"
          />
          <g id="prefix__el3w1e08xi9rz">
            <path
              d="M283.58 246.42c18 8.88 62.6 12.31 84.45 8.56-19.1.38-54.07-5.76-73.9-16.22-16.38-8.64-30.78-23.76-34-36.92-3.91 19.58 5.49 35.7 23.45 44.58z"
              style={{
                transformOrigin: "313.641px 229.161px",
              }}
              className="prefix__animable"
              id="prefix__elqxxj85bi2h"
              opacity={0.15}
            />
          </g>
          <g id="prefix__eleb17odkcphm">
            <path
              d="M260.1 201.84c17.57-7.08 35.87-3.29 48.26 3.35S358.51 241.11 368 255c0 0-27.11-37.55-56.55-55s-51.35 1.84-51.35 1.84z"
              style={{
                transformOrigin: "314.05px 223.847px",
              }}
              className="prefix__animable"
              id="prefix__eldu7pc6p0hgw"
              fill="#fff"
              opacity={0.5}
            />
          </g>
          <path
            d="M406.82 290.77c-2.94 4.14-13.56-1.15-25.09-10.54l-6.08-13 2.13 9.65a145.64 145.64 0 01-19.51-20.79c3.35-.23 6.62-.59 9.76-1.12l16.12 7.79s27.6 21.08 22.67 28.01z"
            style={{
              transformOrigin: "382.84px 273.583px",
            }}
            id="prefix__eliewj6kt0c9"
            className="prefix__animable"
            fill="#0b345a"
          />
          <g id="prefix__elgdb6iyyzsw4">
            <path
              d="M406.82 290.77c-2.94 4.14-13.56-1.15-25.09-10.54l-6.08-13 2.13 9.65a145.64 145.64 0 01-19.51-20.79c3.35-.23 6.62-.59 9.76-1.12l16.12 7.79s27.6 21.08 22.67 28.01z"
              style={{
                transformOrigin: "382.84px 273.583px",
              }}
              className="prefix__animable"
              id="prefix__el6n1km7e9e54"
              opacity={0.15}
            />
          </g>
          <g id="prefix__elm3fi6r6sub">
            <g
              style={{
                transformOrigin: "371.19px 260.875px",
              }}
              className="prefix__animable"
              id="prefix__el66md3b5tgbs"
              opacity={0.15}
            >
              <path
                d="M358.27 256.1a133.13 133.13 0 009 10.65 35.55 35.55 0 01-5.56-8.81l6.4-1.11 16 5.94L368 255c-3.11.51-6.38.87-9.73 1.1z"
                id="prefix__ely4n9kh7qtbe"
                className="prefix__animable"
                style={{
                  transformOrigin: "371.19px 260.875px",
                }}
              />
            </g>
          </g>
          <path
            d="M384.15 262.77L368 255c-4.29-3.68-5.21-5.48-9.48-8.77a183.35 183.35 0 0121.81-.79l-3.78 5.4 10-5c8.84.85 14.51 2.85 17.72 5.59 9.64 8.2-2.5 15.03-20.12 11.34z"
            style={{
              transformOrigin: "383.097px 254.593px",
            }}
            id="prefix__elqaqsndeenai"
            className="prefix__animable"
            fill="#0b345a"
          />
          <g id="prefix__elyvd7jy73vk">
            <path
              d="M376.58 250.82l3.78-5.4a183.35 183.35 0 00-21.81.79s16.71-.17 19.35.28z"
              style={{
                transformOrigin: "369.455px 248.095px",
              }}
              className="prefix__animable"
              id="prefix__elexa6ujr8isi"
              fill="#fff"
              opacity={0.5}
            />
          </g>
          <g id="prefix__elpupt1up7ga8">
            <path
              d="M393 263.79c12.42.17 19.18-5.63 11.28-12.4-3.21-2.74-8.88-4.74-17.72-5.59l-5 2.51 5.57-1.54s11.38 1.15 16.47 6.77c3.13 3.46-.41 10.16-10.6 10.25z"
              style={{
                transformOrigin: "394.618px 254.797px",
              }}
              className="prefix__animable"
              id="prefix__elzcvg534ooyb"
              fill="#fff"
              opacity={0.5}
            />
          </g>
        </g>
        <path
          d="M351.28 191.51c-10.54 19.93-16.56 33.36-19.87 36.72s-28.3 23-37.33 23.9-17.11-1.86-17.9-6.46a10.56 10.56 0 01-.05-3.9s2.17 1.52 2.28 1.56c2.75.94 6.92.63 8.91-.89 2.94-2.25-3.7-4-5.25-5.88-2-2.35-1.13-4.89 3.86-2.71 4.34 1.91 8.2 3.42 11.29 3.33s20.84-18.69 20.84-18.69 9.52-20.11 13.95-30.85c8.33-20.17 16.48-20.07 20.9-20.17z"
          style={{
            transformOrigin: "314.441px 209.885px",
          }}
          id="prefix__el1luy17utr3i"
          className="prefix__animable"
          fill="#ffa8a7"
        />
        <path
          d="M353.9 166.2c-4.33.43-7.56.62-11.18 2.53-4.39 2.31-5.94 6.44-7.93 11-3.79 8.64-7.39 16.48-7.39 16.48 1.43 3.9 9.48 13.26 16.77 10.54 0 0 6.14-10.6 9.34-17.44 2.99-6.41 3.58-17.85.39-23.11z"
          style={{
            transformOrigin: "341.718px 186.719px",
          }}
          id="prefix__elyoa7pjrr2o"
          className="prefix__animable"
          fill="#0b345a"
        />
      </g>
    </g>
    <defs>
      <filter id="prefix__active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="prefix__hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="red" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0" />
      </filter>
    </defs>
  </svg>
);

export default MisionSVG;
